export default __webpack_public_path__ + "static/gastro-1b37639827e928dd5a2fa606bc170e56.jpg";